import React from 'react';

interface DeactivateAgentsModalProps {
  show: boolean;
  markForPermanentDeletion: boolean;
  onClose: () => void;
  onConfirm: () => void;
  onMarkForPermanentDeletionChange: (checked: boolean) => void;
}

const DeactivateAgentsModal: React.FC<DeactivateAgentsModalProps> = ({
  show,
  markForPermanentDeletion,
  onClose,
  onConfirm,
  onMarkForPermanentDeletionChange,
}) => {
  if (!show) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm transition-opacity">
      <div className="w-full max-w-xl rounded-xl bg-[#1c1c1c] p-6 text-white shadow-2xl border border-gray-700">
        <div className="flex items-center justify-between border-b border-gray-700 pb-3 mb-4">
          <h3 className="text-lg font-semibold">Deactivate Selected Agents</h3>
        </div>

        <p className="text-sm text-gray-300 mb-4">
          Deactivation will disable selected agents. If you want to permanently delete selected agents, check the option below before
          submitting.
        </p>

        <label className="flex items-start gap-3 text-sm text-gray-200 mb-6 cursor-pointer">
          <input
            type="checkbox"
            checked={markForPermanentDeletion}
            onChange={(e) => onMarkForPermanentDeletionChange(e.target.checked)}
            className="sr-only peer"
          />
          <span className="mt-0.5 inline-block h-[18px] w-[18px] shrink-0 rounded-[4px] border-2 border-[#444] bg-transparent transition-colors peer-checked:border-[#00FF00] peer-checked:bg-[#00FF00]" />
          <span>Check this for permanently deleting the agent.</span>
        </label>

        <div className="flex justify-end space-x-3">
          <button
            onClick={onClose}
            className="px-5 py-2 border border-gray-600 rounded-full text-gray-300 hover:bg-gray-700 transition-all"
          >
            Cancel
          </button>
          <button onClick={onConfirm} className="px-5 py-2 bg-red-700 hover:bg-red-800 rounded-full font-medium transition-all text-white">
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeactivateAgentsModal;
